import Item from "antd/es/list/Item";
import React from "react";
import { FaHouseChimneyMedical } from "react-icons/fa6";

const data = [
  {
    id: "section_1",
    title: "ISO 9001:2008 CERTIFIED",
    content:
      "Lifevision Healthcare is an ISO certified Pharma company, committed to high quality products. We have also earned the right amount of trust, respect in the market.",
  },
  {
    id: "section_2",
    title: "OUR QUALITY APPROACH",
    content:
      "We are committed to follow the quality norms for manufacturing products. We formulate all our offered medicines as per the set quality norms.",
  },
  {
    id: "section_3",
    title: "DEDICATED WORKFORCE",
    content:
      "Our team members are quite diverse to create a comprehensive, high-performance culture in our company, which will affect our business outcome.",
  },
  {
    id: "section_4",
    title: "ETHICS AND COMPLIANCE",
    content:
      "Our policies and procedure are carefully designed that our company and partners conduct business in a legal, ethical and responsible manner.",
  },
  {
    id: "section_5",
    title: "AWARDS & ACHIEVEMENTS",
    content:
      "Over the past few years, we have received numerous distinguished awards and recognitions for formulating medicines as per the pharma industrial norms.",
  },
  {
    id: "section_6",
    title: "PACKAGING",
    content:
      "We make use of the proven techniques for packaging all the medicines. By using such advanced techniques, we aim to ensure the leakage & breakage proof delivery.",
  },
];

const Certified = () => {
  return (
    <>
      <section className="certified p-30 bgGradient">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="fisherman-content">
                <h3>ISO Certified</h3>
              </div>
            </div>
            {data.map((item, i) => {
              return (
                <div className="col-lg-4 col-md-6 col-sm-4" key={i}>
                  <div className="certifiedItem">
                    <span className="number"><FaHouseChimneyMedical /></span>
                    <h5>{item.title}</h5>
                    <p>{item.content}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Certified;
